import type { ComponentProps } from 'react'

import { TableHeadContext } from './table-context'

// Resets the head context explicitly: without it a table nested inside a head
// cell would render its body cells as <th>.
export const Footer = (props: ComponentProps<'tfoot'>) => (
  <TableHeadContext value={false}>
    <tfoot {...props} />
  </TableHeadContext>
)
